import { Component } from '@angular/core';

@Component({
    selector: 'lib-larm-historik',
    templateUrl: './larm-historik.component.html',
    styleUrls: ['./larm-historik.component.css'],
    standalone: false
})
export class LarmHistorikComponent {

}
